import { render, staticRenderFns } from "./ThemeTest.vue?vue&type=template&id=a6e7845a&scoped=true&"
import script from "./ThemeTest.vue?vue&type=script&lang=js&"
export * from "./ThemeTest.vue?vue&type=script&lang=js&"
import style0 from "./ThemeTest.vue?vue&type=style&index=0&id=a6e7845a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e7845a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6e7845a')) {
      api.createRecord('a6e7845a', component.options)
    } else {
      api.reload('a6e7845a', component.options)
    }
    module.hot.accept("./ThemeTest.vue?vue&type=template&id=a6e7845a&scoped=true&", function () {
      api.rerender('a6e7845a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/ThemeTest.vue"
export default component.exports